import { useEffect, Suspense, lazy } from "react";
import { toast } from "react-toastify";
import { messaging } from "./utils/firebase";
import { getToken, onMessage } from "firebase/messaging";
import { HashRouter , Route, Routes } from "react-router-dom";
import { ToastContainer, Zoom } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { adminService } from "./services/api";
import { isProduction } from "./utils/constant";

// Layout
import Layout from "./components/Layout/Layout";
import PageNotFound from "./utils/PageNotFound";

// Lazy loaded components
const Login = lazy(() => import("./components/Layout/Auth/Login"));
const Dashboard = lazy(() => import("./components/Pages/Dashboard/Dashboard"));
const Service = lazy(() => import("./components/Pages/Service/Service"));
const ServiceSubCategory = lazy(() => import("./components/Pages/Service/ServiceSubCategory"));
const SOSEmergency = lazy(() => import("./components/SOSEmergency"));
const Banner = lazy(() => import("./components/Banner"));
const Fueltype = lazy(() => import("./components/Pages/CarType/Fueltype"));
const Cartype = lazy(() => import("./components/Pages/CarType/Cartype"));
const CarBrand = lazy(() => import("./components/Pages/ManageCar/CarBrand"));
const Carmodel = lazy(() => import("./components/Pages/ManageCar/Carmodel"));
const UpdateCarModelImage = lazy(() => import("./components/Pages/ManageCar/UpdateCarModelImage"));
const Carmodelfuel = lazy(() => import("./components/Pages/ManageCar/Carmodelfuel"));
const DiscountCoupon = lazy(() => import("./components/DiscountCoupon"));
const Membership = lazy(() => import("./components/Pages/Membership/Membership"));
const ShowUsers = lazy(() => import("./components/Pages/ManageMembers/ShowUsers"));
const ShowMembers = lazy(() => import("./components/Pages/ManageMembers/ShowMembers"));
const ShowVender = lazy(() => import("./components/Pages/ManageMembers/ShowVender"));
const VenderApprovedByAdmin = lazy(() => import("./components/Pages/ManageMembers/VenderApprovedByAdmin"));
const UserJobcartApproved = lazy(() => import("./components/Pages/ManageMembers/UserJobcartApproved"));
const ViewSOSEmergency = lazy(() => import("./components/ViewSOSEmergency"));
const Razorpay = lazy(() => import("./components/Razorpay"));
const ShowMembersBills = lazy(() => import("./components/Pages/ManageMembers/ShowMembersBills"));
const PartnerReports = lazy(() => import("./components/Pages/PartnerReports/PartnerReports"));
const City = lazy(() => import("./components/Pages/City/City"));

function App() {
  useEffect(() => {
    const requestPermission = async () => {
      try {
        const permission = await Notification.requestPermission();
        if (permission === "granted" && isProduction) {
          if ('serviceWorker' in navigator) {
            console.log("Service worker started!");
            const registration = await navigator.serviceWorker.register('/firebase-messaging-sw.js');
            const fcmToken = await getToken(messaging, {
              serviceWorkerRegistration: registration,
              vapidKey: "BPnlg92-YeIzACksYaeezBdP0NgVYzwrmmhvyRLhKNhuxNc22dY9dw6vOc9OCaFcLcpaotRnVTK-6YFi549apC8",
            });

            console.log("FCM Token ====> ", fcmToken);

            if (fcmToken) {
              onMessage(messaging, (payload) => {
                console.log('Message received. ', payload);
                toast.success(`${payload?.notification?.title}`, {
                  position: "top-center",
                  theme: "dark",
                  autoClose: 3600000,
                });
              });

              try {
                await adminService.addNotificationToken(fcmToken);
                console.log("Notification token added successfully");
              } catch (error) {
                console.error("Error adding notification token:", error);
              }
            }
          }
        } else if (permission === "denied") {
          console.warn("Notification permission denied");
        }
      } catch (error) {
        console.error("Error requesting notification permission:", error);
      }
    };

    requestPermission();
  }, []);

  return (
    <HashRouter >
      <ToastContainer
        transition={Zoom}
        position="top-center"
        autoClose={3000}
        hideProgressBar={false}
        newestOnTop={false}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
      />
      <Suspense
        fallback={
          <div className="min-h-screen flex items-center justify-center bg-gray-50">
            <div className="text-center">
              <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-primary-600 mx-auto"></div>
              <p className="mt-4 text-gray-600">Loading...</p>
            </div>
          </div>
        }
      >
        <Routes>
          <Route path="/" element={<Login />} />

          <Route element={<Layout />}>
            <Route path="/dashboard" element={<Dashboard />} />
            <Route path="/partnerReports" element={<PartnerReports />} />
            <Route path="/service" element={<Service />} />
            <Route path="/serviceSubCategory" element={<ServiceSubCategory />} />
            <Route path="/SOSEmergency" element={<SOSEmergency />} />
            <Route path="/banner" element={<Banner />} />
            <Route path="/fueltype" element={<Fueltype />} />
            <Route path="/cartype" element={<Cartype />} />
            <Route path="/carBrand" element={<CarBrand />} />
            <Route path="/carmodel" element={<Carmodel />} />
            <Route path="/updateCarModelImage" element={<UpdateCarModelImage />} />
            <Route path="/carmodelfuel" element={<Carmodelfuel />} />
            <Route path="/discountCoupon" element={<DiscountCoupon />} />
            <Route path="/membership" element={<Membership />} />
            <Route path="/city" element={<City />} />
            <Route path="/showUsers" element={<ShowUsers />} />
            <Route path="/showMembers" element={<ShowMembers />} />
            <Route path="/showVender" element={<ShowVender />} />
            <Route path="/venderApprovedByAdmin" element={<VenderApprovedByAdmin />} />
            <Route path="/userJobcartApproved" element={<UserJobcartApproved />} />
            <Route path="/viewSOSEmergency" element={<ViewSOSEmergency />} />
            <Route path="/razorPay" element={<Razorpay />} />
            <Route path="/showMembersBills" element={<ShowMembersBills />} />
          </Route>

          {/* ✅ keep this LAST */}
          <Route path="*" element={<PageNotFound />} />
        </Routes>

      </Suspense>
    </HashRouter >
  );
}

export default App;
